import { Link } from "react-router-dom"

import "../css/Footer.css"

import { ImLocation } from "react-icons/im";
import { FaPhoneAlt } from "react-icons/fa";
import { TbMailFilled } from "react-icons/tb";

const Footer = () => {
    return (
        <footer className="w100">
            <section id="footer-top" className="flex bc-spica c-white w100">
                <div className="flex">
                    <article className="flex fcol">
                        <p> <ImLocation /> <span>PTL de Valladares. Calle C, nave C9 36315 Vigo, Pontevedra</span></p>
                        <p> <FaPhoneAlt />  <a className="white" href="tel:+34-986-44-90-90" target="_blank" rel="noopener noreferrer">+34 986 44 90 90</a></p>
                        <p> <TbMailFilled /> <a className="white" href="mailto:spica@spica.es"> spica@spica.es</a></p>
                    </article>

                    <article className="flex fcol">
                        <Link className="white" to="/legal">Legal</Link>
                        <Link className="white" to="/politica-de-privacidad">Política de privacidad</Link>
                        <Link className="white" to="/politica-de-cookies">Política de cookies</Link>
                        <Link className="white" to="/certificaciones">Certificaciones</Link>
                        <Link className="white" to="/politica-de-calidad-y-medio-ambiente">Política de calidad y medio ambiente</Link>
                    </article>

                    <article className="flex" style={{ "flexDirection": "row", "alignItems": "center", justifyContent: "center" }}>
                        <div className="flex fcol" style={{ width: "50%", height: "265px", justifyContent: "center" }}>
                            <div style={{ width: "100%" }}>
                                <img tabIndex="-1" style={{ width: "100%" }} alt="logo xacobeo" src="/images/xacobeo-21.webp" />
                            </div>
                            <div style={{ width: "100%" }}>
                                <img style={{ width: "100%" }} alt="logo principia" src="/images/principia.webp" />
                            </div>
                            <div style={{ width: "100%" }}>
                                <img alt="logo" src="/images/iso_9001_14001.png" style={{ width: "100%" }} />
                            </div>
                        </div>

                        <div style={{ width: "50%" }}>
                            <img alt="logo" src="/images/ENS-ALTA.png" style={{ width: "100%" }} />
                        </div>
                    </article>
                </div>
            </section >

            <section id="footer-mid">
                <Link to="/igape" className="">
                    <p style={{ color: "#585858" }}>
                        Proxecto cofinanciado por IGAPE, Xunta de Galicia e Fondo Europeo de Desenvolvemento Rexional do Programa Operativo 2014-2020
                    </p>
                    <div>
                        <img alt="logo" className="h200" src="/images/instituto-xunto.webp" />
                        <img alt="logo" className="h200" src="/images/logo-ue.webp" />
                        <img alt="logo" className="h200" src="/images/xacobeo-22.webp" />
                    </div>
                </Link>
            </section>

            <section id="footer-low" className="flex">
                <p>Spica SL ® Todos los derechos reservados</p>
                <Link className="white" to="/programa-innocamaras-2020">PROGRAMA INNOCÁMARAS 2020</Link>
            </section>
        </footer >
    )
}

export default Footer
